export const isCrawler = (): boolean => {
  if (typeof window === 'undefined') {
    // If running on a server (future-proofing for SSR), assume not a typical user browser.
    // You might refine this logic if you do server-side rendering.
    return true; 
  }

  const userAgent = navigator.userAgent;
  if (!userAgent) {
    return false;
  }

  // In isCrawler.ts, add more comprehensive detection:
  const botPatterns = [
    'googlebot', 'bingbot', 'slurp', 'duckduckbot', 'baiduspider', 
    'yandexbot', 'sogou', 'exabot', 'facebot', 'ia_archiver', 'adsbot',
    'mediapartners-google', 'adsbot-google', 'googlebot-news', 
    'googlebot-image', 'googlebot-video', 'apis-google',
    'google-inspectiontool' // Critical: This is what Search Console uses!
  ].join('|');
  
  const crawlerRegex = new RegExp(botPatterns, 'i');
  
  return crawlerRegex.test(userAgent);
}; 